export default __webpack_public_path__ + "static/media/1014.81d9be24.svg";